import type { LinkTarget } from '@/graphql/api'
import type { AnchorTarget } from '@/components/ui/buttons/useThButton'
import { assertNever } from '@/helpers/index'

export function linkTargetToAnchorTarget(
    target: LinkTarget
): AnchorTarget | undefined {
    switch (target) {
        case 'BLANK':
            return '_blank'
        case 'SELF':
            return '_self'
        default:
            return assertNever(target, undefined)
    }
}
